import { siteFeatures } from '@/mocks/faq';

export default function FeaturesSection() {
  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950">
            为什么选择我们
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            数百万麻将爱好者的共同选择，用实力说话
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {siteFeatures.map((feature) => (
            <div
              key={feature.title}
              className="group p-5 md:p-6 bg-background-100 rounded-lg hover:bg-background-200/70 transition-all duration-200 cursor-pointer"
            >
              <div className="w-11 h-11 md:w-12 md:h-12 rounded-lg bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-200 transition-colors">
                <i className={`${feature.icon} text-lg md:text-xl text-primary-600`}></i>
              </div>
              <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}